/* eslint-disable no-bitwise */
/* eslint-disable no-unused-vars */
// import Glide from '@glidejs/glide';

var maxHeight = 0;
function sizing() {

  jQuery('.prelegents').find('.c-tease').each(function(){
    var thisH = jQuery(this).height();
    if (thisH > maxHeight) { maxHeight = thisH; }
   // jQuery(this).css('min-height', maxHeight);
 });
 
 jQuery('.prelegents').find('.c-tease').css('min-height', maxHeight);

}

jQuery(document).ready(sizing);
jQuery(window).resize(sizing);


const carousels = () => {
  /**
   * News carousel (main page)
   */
  const news = document.querySelectorAll('.js-news-carousel');
  if (news) {
    news.forEach(carousel => {
      let glide = new Glide(carousel, {
        type: 'carousel',
        startAt: 0,
        perView: 3,
        gap: 30,
        autoheight: true,
        breakpoints: {
          1280: {
            perView: 2,
          },
          800: {
            gap: 20,
            perView: 2,
          },
          600: {
            gap: 10,
            perView: 1.1,
          },
        },
      });
      glide.mount();
    });
  }

    /**
   * places carousel (main page)
   */
     const places = document.querySelectorAll('.js-places-carousel');
     if (places) {
  
      places.forEach(carousel => {
         let glide = new Glide(carousel, {
           autoplay: 5000,
           type: 'slider',
           bound: false,
           startAt: 0,
           rewind:false,
           perTouch:1,
           perView: 3,
           gap: 30,
           autoheight: true,
           breakpoints: {
             1280: {
               perView: 3,
             },
             800: {
               gap: 20,
               perView: 2,
             },
             600: {
               gap: 10,
               perView: 1.1,
             },
           },
         });
          glide.mount();
       });

  

     }

 

  /**
   * Activities carousel (main page)
   */
  const activities = document.querySelectorAll('.js-activities-carousel');
  if (activities) {
    activities.forEach(carousel => {
      let glide = new Glide(carousel, {
        autoplay: 5000,
        type: 'slider',
        bound: true,
        startAt: 0,
        perView: 4,
        gap: 30,
        autoheight: true,
        breakpoints: {
          1280: {
            perView: 3,
          },
          800: {
            gap: 20,
            perView: 2,
          },
          600: {
            gap: 10,
            perView: 1.1,
          },
        },
      });
      glide.mount();
    });
  }

  /**
   * News carousel (main page)
   */
  const calendar = document.querySelectorAll('.js-calendar-carousel');
  if (calendar) {
    calendar.forEach(carousel => {
      let glide = new Glide(carousel, {
        type: 'carousel',
        startAt: 0,
        perView: 2,
        gap: 30,
        autoheight: true,
        breakpoints: {
          1440: {
            perView: 2,
          },
          800: {
            gap: 20,
            perView: 2,
          },
          600: {
            autoplay: 5000,
            gap: 10,
            perView: 1.1,
          },
        },
      });
      glide.mount();
    });
  }

  /**
   * References carousel (main page)
   */
  const references = document.querySelectorAll('.js-references-carousel');
  if (references) {
    references.forEach(carousel => {
      let glide = new Glide(carousel, {
        autoplay: 5000,
        type: 'carousel',
        startAt: 0,
        perView: 4,
        gap: 30,
        autoheight: true,
        breakpoints: {
          1440: {
            perView: 4,
          },
          800: {
            gap: 20,
            perView: 3,
          },
          600: {
            gap: 10,
            perView: 1.1,
          },
        },
      });
      glide.mount();
    });
  }

  /**
   * Gallery carousel)
   */
  const gallery = document.querySelectorAll('.js-gallery-carousel');
  if (gallery) {
    gallery.forEach(carousel => {
      let glide = new Glide(carousel, {
        autoplay: 5000,
        type: 'carousel',
        startAt: 0,
        perView: 4,
        gap: 30,
        breakpoints: {
          1440: {
            perView: 5,
          },
          800: {
            perView: 2,
          },
          600: {
            gap: 10,
            perView: 1.1,
          },
        },
      });
      glide.mount();
    });
  }

  /**
 * About carousel)
 */
  const about = document.querySelectorAll('.js-about-carousel');
  if (about) {
    about.forEach(carousel => {
      let glide = new Glide(carousel, {
        type: 'carousel',
        startAt: 0,
        perView: 4,
        gap: 30,
        breakpoints: {
          1440: {
            perView: 4,
          },
          800: {
            perView: 2,
          },
          600: {
            gap: 10,
            perView: 1.1,
          },
        },
      });
      glide.mount();
    });
  }

  /**
   * Partners carousel (event singular)
   */
  const partners = document.querySelectorAll('.js-partners-carousel');
  if (partners) {
    partners.forEach(carousel => {
      let glide = new Glide(carousel, {
        autoplay: 5000,
        type: 'slider',
        bound: true,
      //  focusAt: 'center',
        startAt: 0,
        perView: 6,
        gap: 30,
        breakpoints: {
          1440: {
            gap: 20,
            perView: 6,
          },
          800: {
            gap: 15,
            perView: 4,
          },
          600: {
            gap: 10,
            perView: 2,
          },
          400: {
            gap: 10,
            perView: 1.5,
          },
          360: {
            gap: 10,
            perView: 1.2,
          },
        },
      });
      glide.mount();
    });
  }

  /**
   * Partners carousel (event singular)
   */
   const mediaAboutCarousel = document.querySelectorAll('.js-media-about-carousel');
   if (mediaAboutCarousel) {
    mediaAboutCarousel.forEach(carousel => {
       let glide = new Glide(carousel, {
         autoplay: 5000,
         type: 'slider',
         bound: true,
         startAt: 0,
         perView: 6,
         gap: 30,
         breakpoints: {
           1440: {
             perView: 6,
           },
           800: {
             perView: 4,
           },
           600: {
             perView: 2,
           },
           400: {
             perView: 1.5,
           },
           360: {
             perView: 1.2,
           },
         },
       });
       glide.mount();
     });
   }

  /**
   * Partners with cat carousel (partners page)
   */
  const partnersCat = document.querySelectorAll('.js-partners-carousel-cat');
  if (partnersCat) {
    partnersCat.forEach(carousel => {
      let glide = new Glide(carousel, {
        autoplay: 5000,
        type: 'carousel',
        startAt: 1,
        perView: 2,
        gap: 30,
        breakpoints: {
          1440: {
            perView: 2,
          },
          800: {
            perView: 2,
          },
          600: {
            gap: 10,
            perView: 1.5,
          },
        },
      });
      glide.mount();
    });
  }


  /**
   * Speakers carousel
   */
  const SpeakerCarousels = document.querySelectorAll('.js-speaker-carousel');
  if (SpeakerCarousels) {
    SpeakerCarousels.forEach(carousel => {
      let glide = new Glide(carousel, {
        autoplay: 9985000,
        bound: true,
        type: 'slider',
        startAt: 0,
        perView: 3,
        gap: 30,
        breakpoints: {
          1440: {
            gap: 30,
            perView: 3,
          },
          1280: {
            gap: 15,
            perView: 2,
          },
          1024: {
            gap: 10,
            perView: 2,
          },
          768: {
            gap: 10,
            perView: 1,
          },
          600: {
            gap: 0,
            perView: 1,
          },
          400: {
            gap: 0,
            perView: 1,
          },
        },
      });
      glide.mount();
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      }, 10);
    })
  }

  /**
   * New testimonials carousel
   */
  const newTestimonialsCarousel = document.querySelectorAll('.js-testimonials-carousel');
  if (newTestimonialsCarousel) {
    newTestimonialsCarousel.forEach(carousel => {
      let glide = new Glide(carousel, {
        autoplay: 5000,
        bound: true,
        type: 'slider',
        startAt: 0,
        perView: 4,
        gap: 30,
        breakpoints: {
          1440: {
            gap: 30,
            perView: 3,
          },
          1280: {
            gap: 15,
            perView: 3,
          },
          1024: {
            gap: 15,
            perView: 3,
          },
          768: {
            gap: 15,
            perView: 2.5,
          },
          600: {
            gap: 15,
            perView: 1.2,
          },
          400: {
            gap: 10,
            perView: 1.05,
          },
        },
      });
      glide.mount();
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      }, 10);
    });
  }

  /**
   * Map carousel (about us page)
   */
  const MapCarousels = document.querySelectorAll('.js-map-carousel');
  if (MapCarousels) {
    MapCarousels.forEach(carousel => {
      let glide = new Glide(carousel, {
        autoplay: 5000,
        type: 'carousel',
        startAt: 0,
        perView: 7,
        breakpoints: {
          1440: {
            perView: 5,
          },
          1280: {
            gap: 47,
            perView: 4,
          },
          800: {
            perView: 3,
          },
          600: {
            perView: 2,
          },
          400: {
            perView: 2,
          },
        },
      });
      glide.mount();
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      }, 10);
    });

   

  /**
   * Team carousel (All pages)
   */
  let teamCarousels = document.querySelectorAll('.js-team-carousel');
  if (teamCarousels) {
    for (let i = 1; i < 5; i++) {
      let className = `.js-team-carousel-${i}`;
      let differentTeamCarousels = document.querySelectorAll(className);
      differentTeamCarousels.forEach(carousel => {
        let glide = new Glide(carousel, {
          autoplay: 5000,
          type: 'slider',
          bound: true,
          startAt: 0,
          perView: i,
          gap: 25,
          breakpoints: {
            1440: {
              perView: i * 1,
            },
            800: {
              perView: 3,
            },
            600: {
              gap: 10,
              perView: 1.1,
            },
          },
        });
        glide.mount();
      });
    }
  }

  /**
   * Host City carousel (event singular)
   */
  const hostCarousel = document.querySelectorAll('.js-host-city-carousel');
  if (hostCarousel) {
    hostCarousel.forEach(carousel => {
      let glide = new Glide(carousel, {
        autoplay: 5000,
        type: 'carousel',
        perView: 3,
        gap: 30,
        breakpoints: {
          1440: {
            perView: 4,
          },
          800: {
            gap: 20,
            perView: 3,
          },
          600: {
            gap: 10,
            perView: 1.1,
          },
        },
      });
      glide.mount();
    });
  }


  /**
   * Checklist caousel (page)
   */
  const checcklistCarousel = document.querySelectorAll(
    '.js-checklist-carousel',
  );
  if (checcklistCarousel) {
    checcklistCarousel.forEach(carousel => {
      let glide = new Glide(carousel, {
        autoplay: 5000,
        type: 'carousel',
        perView: 1,
        gap: 0,
      });
      glide.mount();
    });
  }

}





const points = document.querySelectorAll('.js-project-location');
points.forEach(point => {
  point.addEventListener('click', e => {
    e.preventDefault();

    let ajaxData2 = {
      action: 'get_projects',
      id: point.dataset.term_id,
    };

    let ajaxData = {
      action: 'get_events',
      id: point.dataset.term_id,
      };



      

    let ajaxParameters = Object.entries(ajaxData)
      .map(e => e.join('='))
      .join('&');


    /**
     * Ajax post
     */
    const ajax_url = document.querySelector('meta[name="ajax_url"]').content;
    let request = new XMLHttpRequest();
    request.open('POST', ajax_url, true);
    request.setRequestHeader(
      'Content-Type',
      'application/x-www-form-urlencoded;',
    );
    request.onload = function () {
      let results = document.querySelector('.js-projects-by-events');
      let scrolltoresults = document.querySelector('.js-projects-by-location');
      results.innerHTML = this.response;
      scrolltoresults.scrollIntoView({ behavior: "smooth" });
    };
    request.onerror = function () {
      console.log(ajaxData);
      console.error(this.response);
    };
    request.send(ajaxParameters);
    
  });

//a2

point.addEventListener('click', e => {
e.preventDefault();

let ajaxData2 = {
action: 'get_projects',
id: point.dataset.term_id,
};




let ajaxParameters = Object.entries(ajaxData2)
.map(e => e.join('='))
.join('&');


/**
* Ajax post
*/
const ajax_url = document.querySelector('meta[name="ajax_url"]').content;
let request = new XMLHttpRequest();
request.open('POST', ajax_url, true);
request.setRequestHeader(
'Content-Type',
'application/x-www-form-urlencoded;',
);
request.onload = function () {
let results = document.querySelector('.js-projects-by-location');
let scrolltoresults = document.querySelector('.js-projects-by-location');    
results.innerHTML = this.response;
scrolltoresults.scrollIntoView({ behavior: "smooth" });
};
request.onerror = function () {
console.log(ajaxData);
console.error(this.response);
};
request.send(ajaxParameters);

});

//

});








}
export default carousels;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/eco-chisel/src/scripts/modules/carousels.js